import loadable from '@loadable/component';
import { BoxIndicator } from '@classtinginc/design-system';

const UpdateSchoolInfoPage = loadable(() => import('./UpdateSchoolInfoPage'), {
  fallback: <BoxIndicator />,
});

export default UpdateSchoolInfoPage;
